import { Space } from '@dnb/eufemia';
import { cloud, file_contract, layout_card, loan, news, office_buildings, play } from '@dnb/eufemia/icons';
import type { JSX } from 'react';

import HeroPage from '@/components/HeroPage';
import { HeroContent } from '@/components/HeroPage/HeroContent';
import Tile from '@/components/Tile';
import useAuth from '@/hooks/useAuth';
import useFeatureFlags from '@/hooks/useFeatureFlags';

import ApiStatusWidget from './ApiStatusWidget';
import InformationBox from './InformationBox/InformationBox';

import McpIcon from '@/icons/Mcp.svg';

import Inbox from '@/illustrations/Inbox.svg?url';

export default function Landing(): JSX.Element {
  const { isInternal } = useAuth();
  const { featureFlags } = useFeatureFlags();
  return (
    <HeroPage
      banner="common"
      heroChildren={<ApiStatusWidget />}
      tabTitle="DNB Developer"
      title="Welcome to the developer portal"
      wideHeader
    >
      <HeroContent>
        <div className="flex flex-wrap justify-center gap-4">
          <Tile icon={file_contract} linkTo="/explorer/apis/regulatory" title="Regulatory APIs" />
          <Tile icon={cloud} linkTo="/explorer/apis/commercial" title="Commercial APIs" />
          {!isInternal && <Tile icon={play} linkTo="/getting-started" title="Get started" />}
          {isInternal && (
            <>
              <Tile icon={office_buildings} linkTo="/explorer/apis/internal" title="Internal APIs" />
              {isInternal && (
                <Tile description="Discover events" icon={news} linkTo="/explorer/events" title="Events" />
              )}
              {isInternal && featureFlags.ENABLE_MCP_PAGES && (
                <Tile
                  description="Discover MCP servers"
                  icon={<McpIcon style={{ color: 'var(--color-sea-green)' }} />}
                  linkTo="/explorer/mcps"
                  title="MCPs"
                />
              )}
              {featureFlags.ENABLE_COMMON_REPO_API && (
                <Tile
                  description="All API Contracts in Gitlab"
                  icon={layout_card}
                  linkTo="/api-contracts"
                  title="API Contracts"
                />
              )}
            </>
          )}
          <Tile
            description="PSD2 channel and API metrics"
            icon={loan}
            linkTo="/channel-statistics"
            title="Digital Channel Statistics"
          />
        </div>
        <Space bottom="large" top="4rem">
          <InformationBox
            buttonText="News page"
            description="Keep up with new features and changes to the developer portal."
            illustration={Inbox}
            title="Check out our news page"
          />
        </Space>
      </HeroContent>
    </HeroPage>
  );
}
